import React from 'react';
import { Button } from '@mantine/core';

export default function BasicButton({
  primary = false,
  secondary = false,
  variant,
  loading = false,
  style = {},
  onClick,
  disabled = false,
  text = 'Basic',
  type = 'button',
  color,
  size,
  leftSection,
  leftIcon,
}) {
  return (
    <Button
      style={style}
      size={size ? size : 'sm'}
      color={color ? color : 'blue'}
      variant={variant ? variant : 'light'}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      loading={loading}
      leftSection={leftSection || leftIcon}
    >
      {text}
    </Button>
  );
}
